import React, { Component } from 'react';
import { useEffect, useState } from "react";

  const Krovlyaprice = () => {
  const [item, setItem] = useState([]);
  const divStyle = {
    paddingTop: '40px',
  };
  
  useEffect(()=>{
    fetch('http://kosdom.ru/krovlya.php')
    .then(res => res.json())
    .then(
      (result)=>{
          setItem(result);
        //console.log(result);
      }
    )
  },[]);

  return (
    <div className="container ">
      <div className="row p-0 overflow-hidden shadow" style={{borderRadius:10}}>
        <div className="col-md-3"></div>
            <h1 style={divStyle}>Кровельные работы</h1>
              {item.map(item => <div key={item.id} className="row  mt-4">
              {/* <div className="col-lg-1" id={"a"+item.id%2}>{item.id%2}</div>*/} 
              <div className="col-lg-1" ></div> 
              <div className="col-lg-8" id={"a"+item.sort%2}>{item.usluga }</div>
              <div className="col-lg-2" id={"a"+item.sort%2}>{item.price }</div></div>
            )}
      </div>
    </div>
  )}


export default Krovlyaprice;